/* ==========================================================================
   predictive-search.js — live results in the search overlay.
   Uses Shopify's Predictive Search API rendered through a theme section.
   ========================================================================== */
(function () {
  'use strict';

  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-search-input]');
      this.results = this.querySelector('[data-search-results]');
      this.defaults = this.querySelector('[data-search-default]');
      this.status = this.querySelector('[data-search-status]');
      if (!this.input || !this.results) return;

      this.abortController = null;
      this.debounce = null;

      this.input.addEventListener('input', this.onInput.bind(this));

      this.addEventListener('click', function (event) {
        var term = event.target.closest('[data-search-term]');
        if (!term) return;

        this.input.value = term.dataset.searchTerm;
        this.input.focus();
        this.search();
      }.bind(this));
    }

    onInput() {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(this.search.bind(this), 250);
    }

    search() {
      var term = this.input.value.trim();

      if (term.length < 2) {
        this.reset();
        return;
      }

      if (this.abortController) this.abortController.abort();
      this.abortController = new AbortController();

      this.setBusy(true);

      var url =
        window.routes.predictive_search_url +
        '?q=' +
        encodeURIComponent(term) +
        '&resources[type]=product,article,page&resources[limit]=6&section_id=predictive-search';

      fetch(url, { signal: this.abortController.signal })
        .then(function (response) {
          return response.text();
        })
        .then(
          function (html) {
            var parsed = new DOMParser().parseFromString(html, 'text/html');
            var fresh = parsed.querySelector('[data-search-results]');
            if (!fresh) return;

            this.results.innerHTML = fresh.innerHTML;
            this.results.hidden = false;
            if (this.defaults) this.defaults.hidden = true;

            if (this.status) {
              this.status.textContent = fresh.dataset.resultsCount || '';
            }
          }.bind(this)
        )
        .catch(function (error) {
          if (error.name !== 'AbortError') throw error;
        })
        .finally(
          function () {
            this.setBusy(false);
          }.bind(this)
        );
    }

    reset() {
      this.results.hidden = true;
      this.results.innerHTML = '';
      if (this.defaults) this.defaults.hidden = false;
      if (this.status) this.status.textContent = '';
    }

    setBusy(state) {
      this.setAttribute('aria-busy', String(state));
    }
  }

  if (!customElements.get('predictive-search')) {
    customElements.define('predictive-search', PredictiveSearch);
  }
})();
